import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';

// 스켈레톤 애니메이션 키프레임
const shimmer = keyframes`
  0% {
    background-position: -100% 0;
  }
  100% {
    background-position: 100% 0;
  }
`;

type SkeletonProps = {
  height: `${number}px` | `${number}%`;
};
const Skeleton = ({ height }: SkeletonProps) => {
  return <SkeletonContainer $height={height} />;
};

type SkeletonContainerProps = {
  $height: `${number}px` | `${number}%`;
};

// 스켈레톤 기본 스타일
const SkeletonContainer = styled.div<SkeletonContainerProps>`
  background: #e0e0e0;
  background-image: linear-gradient(to right, #e0e0e0 0%, #f0f0f0 20%, #e0e0e0 40%, #e0e0e0 100%);
  background-repeat: no-repeat;
  background-size: 200% 100%;
  animation: ${shimmer} 1.5s infinite linear;
  width: 100%;
  height: ${({ $height }) => `${$height}`}; // 기본 높이 설정
  border-radius: 8px;
  opacity: 0.7;
`;

// 스켈레톤을 다양한 사이즈로 쉽게 커스터마이징
export const SkeletonCircle = styled(Skeleton)`
  width: 40px;
  height: 40px;
  border-radius: 50%;
`;

export const SkeletonLine = styled(Skeleton)<{ width?: string; height?: string }>`
  width: ${({ width }) => width || '100%'};
  height: ${({ height }) => height || '1em'};
  margin-bottom: 8px;
`;
export default Skeleton;
